<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.newlandPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.newlandPay.application") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.newlandPay.application_title") }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.newlandPay.newland_mercId") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.newlandPay.newland_mercId')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.newland_mercId"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'newland_mercId')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.newlandPay.newland_orgNo") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.newlandPay.newland_orgNo')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.newland_orgNo"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'newland_orgNo')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.newlandPay.newland_trmNo") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.newlandPay.newland_trmNo')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.newland_trmNo"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'newland_trmNo')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.newlandPay.newland_transactionKey") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.newlandPay.newland_transactionKey')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.newland_transactionKey"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'newland_transactionKey')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.newlandPay.wechat_mini_app_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.newlandPay.wechat_mini_app_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_app_id"
                      single-line
                      disabled
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_app_id')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                    <a @click="$router.push('/settings/mini-develop-program')">
                      {{ $t("Payment.newlandPay.mini_develop_program") }}
                    </a>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.newlandPay.newlandpay_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.newlandpay_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                color="success"
                block
                @click="
                  settings.newlandpay_enable ? (alertDialog = true) : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.newlandpay')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
    alertDialog: false,
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },

  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "newland_mercId",
          "newland_orgNo",
          "newland_trmNo",
          "newland_transactionKey",
          "wechat_mini_app_id",
          "newlandpay_enable",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.newlandpay_enable == null ||
              typeof this.settings.newlandpay_enable == "undefined" ||
              this.settings.newlandpay_enable == undefined
            ) {
              this.settings.newlandpay_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Payment.newLandPaySave(this.settings).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/payment");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>